import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Gift, X } from "lucide-react";

const KEY = "trial_referral_banner_dismissed";
const today = () => new Date().toISOString().slice(0, 10);

export default function TrialReferralBanner() {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    if (localStorage.getItem(KEY) === today()) setDismissed(true);
    api.get("/billing/subscription").then(({ data }) => setSub(data)).catch(() => {});
    api.get("/referrals/me").then(({ data }) => setEnabled(data.enabled !== false)).catch(() => {});
  }, [user]);

  if (!user || dismissed || !enabled || !sub) return null;

  const paid = sub.status === "active" && ["lite", "pro", "sponsored"].includes(sub.tier);
  const ended = !!sub.locked;
  const ending = !ended && sub.trial_days_left != null && sub.trial_days_left <= 2;
  if (paid || (!ending && !ended)) return null;

  const dismiss = () => {
    localStorage.setItem(KEY, today());
    setDismissed(true);
  };

  const msg = ended
    ? "Your free trial has ended — invite 3 friends who sign up and verify to get 7 days back, free."
    : `Your free trial ends in ${sub.trial_days_left} day${sub.trial_days_left === 1 ? "" : "s"} — invite 3 friends and earn 7 free days.`;

  return (
    <div className="bg-[#1a3060]" data-testid="trial-referral-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <Gift className="h-4 w-4 text-gold shrink-0" strokeWidth={1.9} />
        <span className="text-sm text-white">{msg}</span>
        <Link
          to="/referrals"
          data-testid="trial-referral-invite-btn"
          className="text-sm font-semibold text-gold underline underline-offset-2 hover:text-white"
        >
          Invite friends &rarr;
        </Link>
        <button
          onClick={dismiss}
          data-testid="trial-referral-dismiss"
          aria-label="Dismiss"
          className="ml-1 text-white/60 hover:text-white transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
